import axios from 'axios';

export const wmsApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

wmsApi.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// --- PRODUCTOS WMS ---
export const getWmsProductos = async () => {
  const response = await wmsApi.get('/api/v1/wms/productos');
  return response.data;
};

export const createWmsProducto = async (productoData) => {
  const response = await wmsApi.post('/api/v1/wms/productos', productoData);
  return response.data;
};

export const updateWmsProducto = async (id, productoData) => {
  const response = await wmsApi.put(`/api/v1/wms/productos/${id}`, productoData);
  return response.data;
};

export const deleteWmsProducto = async (id) => {
  const response = await wmsApi.delete(`/api/v1/wms/productos/${id}`);
  return response.data;
};

export const getWmsProductoBySku = async (sku) => {
  const response = await wmsApi.get(`/api/v1/wms/productos/sku/${sku}`);
  return response.data;
};

export const getWmsProductoByBarcode = async (barcode) => {
  const response = await wmsApi.get(`/api/v1/wms/productos/barcode/${barcode}`);
  return response.data;
};

export const getWmsProductosByIds = async (ids) => {
  const promises = ids.map(id => wmsApi.get(`/api/v1/wms/productos/${id}`));
  const results = await Promise.all(promises);
  return results.map(r => r.data);
};

export const getSiguienteSku = async () => {
  const response = await wmsApi.get('/api/v1/wms/productos/siguiente-sku');
  return response.data.siguiente_sku;
};
